.sliderPopover {
  position: absolute;
  z-index: 50;
  top: 16px;
  right: 70px;
  background-color: var(--sparky-brand-white);
  border-radius: 4px;
  pointer-events: all;
  border: 1px solid var(--border-subtle-01);
  padding: var(--spacing-12);
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  width: 380px;

  .sliderRow {
    display: flex;
    margin-top: var(--spacing-08);
    column-gap: var(--spacing-08);
    align-items: center;

    .textInput {
      width: 90px;
      height: 32px;
      background: var(--bg);

      input {
        font-size: 14px;
        color: var(--text-placeholder);
      }
    }
  }

  .sliderContainer {
    display: flex;
    height: 44px;
    align-items: center;
    column-gap: var(--spacing-08);
  }

  .selectButton {
    margin: 0 0 0 auto;
  }
}
